<template>
  <div>
    <Loading v-if="loading" />

    <div v-else-if="hasExternalPosOnlySubscription" class="flex items-center justify-center min-h-screen">
      <div class="p-4 rounded-md bg-blue-50 border border-blue-200 text-blue-800 text-center text-lg">
        <span class="font-medium">ℹ️</span>
        La souscription se fait depuis le logiciel de caisse.
      </div>
    </div>

    <div v-else-if="getIndex.length > 0">
      <SubscriptionForm
        v-if="showDefaultSubscriptionForm"
        ref="subscriptionForm"
        :categories="getIndex"
        :offeredMonths="offeredMonths"
      />
      <SubscriptionFormWithSteps
        v-else
        ref="subscriptionFormWithSteps"
        :categories="getIndex"
        :offeredMonths="offeredMonths"
      />
    </div>
    <div v-else class="flex items-center justify-center min-h-screen">
      <div class="text-center text-xl">
        <p>Aucune offre d'assurance n'est activée pour ce magasin.</p>
        <p>Vous pouvez contacter le support si vous avez besoin d'aide.</p>
      </div>
    </div>
  </div>
</template>

<script>
import DiscountsService from "@/api/services/discounts";
import { mapActions, mapState, mapGetters } from "vuex";
import { Loading, toCamelCase } from "@estaly/ui";
import SubscriptionForm from "@/components/pos/subscription/SubscriptionForm.vue";
import SubscriptionFormWithSteps from "@/components/pos/subscription/SubscriptionFormWithSteps.vue";

export default {
  components: {
    Loading,
    SubscriptionForm,
    SubscriptionFormWithSteps,
  },

  data: () => {
    return {
      offeredMonths: null,
      loading: false,
    };
  },

  watch: {
    selectedStoreId(newValue) {
      if (newValue !== 0) {
        this.loadData();
        this.$refs.subscriptionForm?.resetAttributes?.();
        this.$refs.subscriptionFormWithSteps?.resetAttributes?.();
      }
    },
  },

  computed: {
    ...mapState("store", ["selectedStoreId"]),
    ...mapGetters("businessVerticals", ["getIndex", "hasMpcpOffers", "hasExternalPosOnlySubscription"]),

    showDefaultSubscriptionForm() {
      return !this.hasMpcpOffers;
    },
  },

  beforeMount() {
    this.loadData();
  },

  methods: {
    ...mapActions("businessVerticals", ["fetchIndex"]),

    async loadData() {
      this.loading = true;
      await Promise.all([this.getCategories(), this.getDiscounts()]);
      this.loading = false;
    },

    async getCategories() {
      await this.fetchIndex({ storeId: [this.selectedStoreId], enabled: true, includes: ["contract_distribution"] });
    },

    async getDiscounts() {
      const response = await DiscountsService.fetch(this.selectedStoreId);
      if (!response?.success) return;

      const data = toCamelCase(response.data);
      this.offeredMonths = data.discount?.offeredMonths ?? null;
    },
  },
};
</script>
